export default {
  addressbook: "Libreta de Direcciones",
  save: "Guardar",
  saveChanges: "Guardar Cambios",
  undoChanges: "Deshacer Cambios",
  create: "Crear",
  add: "Agregar",
  new: "Nuevo",
  assign: "Asignar",
  change: "Cambiar",
  next: "Siguiente",
  back: "Atrás",
  edit: "Editar",
  continue: "Continuar",
  confirm: "Confirmar",
  remove: "Eliminar",
  submit: "Enviar",
  submitted: "Enviado",
  transfer: "Transferir",
  send: "Enviar",
  yes: "Sí",
  no: "No",
  models: "Modelos",
  cancel: "Cancelar",
  close: "Cerrar",
  OK: "OK",
  tryAgain: "Intentar de nuevo",
  createNewAttribute: "Crear nuevo atributo",
  addExistingAttribute: "Agregar atributo existente",
  addNewProject: "Agregar nuevo proyecto",
  addNewManufacturer: "Agregar nuevo fabricante",
  addNewBillingAddress: "Agregar nueva dirección de facturación",
  done: "Hecho",
  SearchByFilters: "Buscar por filtros",
  enterCoordinates: "Ingresar coordenadas",
  reserve: "Reservar",
  settings: "Configuración",
  requestDataCorrection: "Solicitar corrección de datos",
  approve: "Aprobar",
  deny: "Denegar",
  delete: "Eliminar",
  run: "Ejecutar",
  unselect: "Deseleccionar",
  attributeSets: "Conjuntos de Atributos",
  attributes: "Atributos",
  createdBy: "creado por",
  sort: "ordenar",
  replace: "reemplazar",
  unassign: "desasignar",
  photo: "Fotos",
  newLog: "Nuevo Registro",
  or: "o",
  downloadMap: "Descargar mapa como JPG",
  showRelatedAssets: "Mostrar activos relacionados",
  hideRelatedAssets: "ocultar activos relacionados",
  showAllAssets: "Mostrar todos los Activos",
  resetAllFilters: "Restablecer todos los filtros",
  hideAllAssets: "Ocultar todos los Activos",
  hideAll: "Ocultar todo",
  showAll: "Mostrar todo",
  copyAccessRoute: "Copiar ruta de acceso",
  check: "Verificar",
  goToMoreDetails: "Mostrar más detalles",
  clickToUpload: "hacer clic para subir",
  here: "aquí",
  orDragandDrop: "arrastrar y soltar",
  uploadPicture: "Subir Imagen",
  uploadFiles: "Subir Archivos",
  deletePictures: "Eliminar Imágenes",
  deleteFiles: "Eliminar Archivos",
  stopDeleting: "Detener eliminación",
  logout: "Cerrar Sesión",
  editName: "Editar Nombre",
  changePassword: "Cambiar Contraseña",
  editData: "Editar Datos",
};
